import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import BuggyCounter from './BuggyCounter';

function ErrorBoundaryExamplePage() {
  return (
    <div>
      <h1>Error Boundary Example</h1>
      <p>
        This is an example of error boundaries in React 16. Error boundaries
        allow you to display a helpful error message when a portion of your
        React app throws an error. This way you users can keep working. Click on
        the numbers to increase the counters. The counter is programmed to throw
        when it reaches 3. This simulates a JavaScript error in a component.
      </p>
      <p>
        <strong>Note:</strong> When you run this locally, the standard React
        error message screen will display. To see the production error boundary
        behavior on your local machine:
      </p>
      <ol>
        <li>
          Run the production build: <code>npm run build</code>
        </li>
        <li>
          Serve the prod build locally: <code>serve -s build</code>
        </li>
      </ol>
      <hr />
      <ErrorBoundary>
        <p>
          These two counters are inside the same error boundary. If one crashes,
          the error boundary will replace both of them.
        </p>
        <BuggyCounter />
        <BuggyCounter />
      </ErrorBoundary>
      <hr />
      <p>
        These two counters are each inside of their own error boundary. So if
        one crashes, the other is not affected.
      </p>
      <ErrorBoundary>
        <BuggyCounter />
      </ErrorBoundary>
      <ErrorBoundary>
        <BuggyCounter />
      </ErrorBoundary>
    </div>
  );
}

export default ErrorBoundaryExamplePage;



// WEBPACK FOOTER //
// ./src/components/pages/ErrorBoundaryExamplePage/ErrorBoundaryExamplePage.js